import { getFingerprintId } from "@/lib/helpers/fingerprint"
import { PSEUDO_ID_COOKIE } from "@/platform/api/constants"
import { readCookie } from "@/platform/browser/cookies"
import { logger } from "@/platform/observability/logger"

// api-v2 400s when these are absent, and its Device row is unique on (manufacturer, model), so ""
// has to stay "" for existing devices to keep matching.
export const deviceDescriptorHeaders: Record<string, string> = {
  "x-device-manufacturer": "",
  "x-device-model": "",
}

export const createDeviceIdHeaders = () => {
  let visitorId: string | null = null
  let pending: Promise<void> | null = null

  const resolveVisitorId = (): Promise<void> => {
    if (!pending) {
      pending = getFingerprintId()
        .then((id) => {
          visitorId = id
        })
        .catch((error: unknown) => logger.error("Fingerprint failed", {}, error as Error))
    }
    return pending
  }

  return (): Record<string, string> => {
    if (typeof window === "undefined") return {}
    if (!visitorId) void resolveVisitorId()
    const id = visitorId ?? readCookie(PSEUDO_ID_COOKIE)
    return id ? { "x-device-id": id } : {}
  }
}

export const deviceIdHeaders = createDeviceIdHeaders()
